const taggedPath = '/tagged/';

// Get current URL
function getCurrentUrl() {
    return window.location.href;
}

/**
 * Get Tags from URL of blog page.
 * * Example:
 * * Input: https://[Store-name].myshopify.com/blogs/news                            -> Output: []
 * * Input: https://[Store-name].myshopify.com/blogs/news/tagged/darts+red-dragon    -> Output: ['dart', 'red dragon]
 * @param {string} url - URL of blog page
 * @returns {Boolean} - The array of tags
 */
function getQueryFromUrl(type) {
    const QUERY_SOURCE = {
        tags: 'tags',
        paginate: 'p'
    };
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    const query = urlParams.get(QUERY_SOURCE[type]);

    return query ? query.split(',') : []
}

/**
 * Update tags to url
 * * Example:
 * * Input: ['darts', 'red-dragon'] -> Output:    https://[Store-name].myshopify.com/blogs/news/tagged/darts+red-dragon
 * @param {Array} tags - Array of tags need to filter
 * @returns {String} - The new URL includes the tags.
 */
function updateUrlWithQuery(type = 'tags', data) {
    const baseUrl = `${window.location.origin}${window.location.pathname}`;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const QUERY_SOURCE = [
        'tags',
        'paginate'
    ];

    if (!data.length || !QUERY_SOURCE.includes(type)) {
        window.location.href = baseUrl;
    } else {
        urlParams.delete('page');

        if (type == 'paginate' && data) {
            urlParams.set('p', data);
            history.replaceState(null, null, `?${urlParams.toString()}`);
        }

        if (type == 'tags' & data.length > 0) {
            urlParams.set('tags', data.join(','));
            urlParams.delete('p');
            history.replaceState(null, null, `?${urlParams.toString()}`);
        }

        updateArticlesByTags();
    }
}

// Handle filter for desktop
function handleDesktopFilterChange(checkbox) {
    // Get value or function
    const tagValue = checkbox.value.toLowerCase().replace(/\s+/g, '-');
    let tags = getQueryFromUrl('tags');

    if (checkbox.checked) {
        // If the tag is checked, push the tag to the tags array if it is not included in the tags array
        if (!tags.includes(tagValue)) {
            tags.push(tagValue);
        }
    } else {
        // If the tag is unchecked, remove the tag from the tags array if it is included in
        tags = tags.filter(tag => tag !== tagValue);
    }

    // Reload page with new URL
    updateUrlWithQuery('tags', tags);
}

// Handle filter for mobile
function handleMobileFilterChange() {
    const checkboxes = document.querySelectorAll('#blogFilterFormMobile input[type=checkbox]');
    let tags = [];

    // Loop to get all tags is checked
    checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
            const tagValue = checkbox.value.toLowerCase().replace(/\s+/g, '-');

            tags.push(tagValue)
        }
    })

    // Return tags array
    return tags;
}

// Handle apply filter click event on mobile
function applyMobileFilter() {
    let tags = handleMobileFilterChange();

    updateUrlWithQuery('tags', tags);
}

// Handle reset filter click event on mobile
function clearMobileFilter() {
    let baseUrl = `${window.location.origin}${window.location.pathname}`;

    window.location.href = baseUrl;
}

// Fetch API to get articles by tags
async function fetchArticlesByTags() {
    const tags = getQueryFromUrl('tags');
    let articles = '';

    if (tags.length > 0) {
        for (let i = 0; i < tags.length; i++) {
            const tag = tags[i];
            let requestResponse;
            let result = await fetch(`/search/suggest?q=${tag}&resources[type]=article&resources[options][fields]=tag&section_id=amb-blog`)
                .then(response => {
                    requestResponse = response;

                    return response.text();
                })
                .then(text => {
                    if (!requestResponse.ok) {
                        throw new Error(`${requestResponse.status}: ${text}`);
                    }

                    const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-amb-blog').innerHTML;

                    return resultsMarkup;
                })
                .catch(function (error) {
                    console.log(error);
                });

            articles += result;
        }

        return articles;
    }
}

// Function to sort articles by reverse published_at date
function sortArticlesByDate(articles) {
    return articles.sort((a, b) => {
        const dateA = new Date(a.querySelector('.blog-date').textContent);
        const dateB = new Date(b.querySelector('.blog-date').textContent);
        return dateB - dateA;
    });
}

// Update article list when tag is selected
async function updateArticlesByTags() {
    const blogSearchSection = document.querySelector('.blog-articles-ajax');
    const blogDefaultSection = document.querySelector('.blog-articles:not(.blog-articles-ajax)');
    const articles = await fetchArticlesByTags();

    updateCheckboxState();

    if (articles) {
        const articlesClear = checkDuplicateArticle(articles);
        const sortedArticles = sortArticlesByDate(Array.from(new DOMParser().parseFromString(articlesClear, 'text/html').querySelectorAll('.articles__article')));
        const articlesWithPagination = toggleArticlesByPagination(sortedArticles.map(article => article.outerHTML).join(''));

        blogSearchSection.innerHTML = articlesWithPagination;

        blogDefaultSection.classList.add('hide');
        blogSearchSection.classList.remove('hide');
    }
}

function checkDuplicateArticle(articlesHTML) {
    if (articlesHTML) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(articlesHTML, 'text/html');
        const tags = getQueryFromUrl('tags');
        const articles = doc.querySelectorAll('.articles__article');

        const uniqueArticlesMap = new Map();

        articles.forEach((article, index) => {
            const articleId = article.getAttribute('data-article-id');
            const articleTags = article.querySelectorAll('.article-tags')[0];

            if (articleTags) {
                let tagValue = articleTags.value;
                let tagArr = JSON.parse(tagValue.replace(/'/g, '"'));

                tagArr = tagArr.map(item => item.toLowerCase().replace(/\s+/g, '-'));

                tagArr.forEach(tag => {
                    if (tags.includes(tag) && !uniqueArticlesMap.has(articleId)) {
                        uniqueArticlesMap.set(articleId, article.outerHTML);
                    }
                })
            }
        });

        const uniqueHtmlString = Array.from(uniqueArticlesMap.values()).join('');

        return uniqueHtmlString;
    }
}

function initPagination(articles) {
    const itemsPerPage = document.querySelectorAll('#blogPagiNum')[0].value;
    const pagination = document.querySelectorAll('.pagination-ajax')[0];
    const defaultPagination = document.querySelectorAll('.pagination-wrapper:not(.pagination-ajax)')[0];
    const currentPage = getQueryFromUrl('paginate').length ? parseInt(getQueryFromUrl('paginate')) : 1;
    let result;

    if (currentPage && itemsPerPage) {
        let startIndex = (currentPage - 1) * itemsPerPage;
        let endIndex = Number(startIndex) + Number(itemsPerPage) - 1;

        result = { startIndex, endIndex };
    }

    initPaginationHtml(articles);

    if (articles.length > itemsPerPage) {
        if(pagination) pagination.classList.remove('hide');
        if(defaultPagination) defaultPagination.classList.add('hide');
    } else {
        if(pagination) pagination.classList.add('hide');
        if(defaultPagination) defaultPagination.classList.add('hide');
    }

    return result;
}

function initPaginationHtml(articles) {
    const itemsPerPage = document.querySelector('#blogPagiNum')?.value;
    const pagination = document.querySelector('.pagination-ajax');

    if (!pagination || !itemsPerPage) return;

    var paginationUrl = new window.URL(getCurrentUrl());
    const paginationList = pagination.querySelector('.pagination__list');

    if (!paginationList) return;

    const pageNum = Math.ceil(articles.length / itemsPerPage);
    const currentPage = getQueryFromUrl('paginate').length ? parseInt(getQueryFromUrl('paginate')) : 1;

    paginationList.innerHTML = '';

    if (pageNum > 1) {
        if (currentPage > 1) {
            const prevItem = document.createElement('li');
            paginationUrl.searchParams.set('p', currentPage - 1);
            prevItem.innerHTML = `
                <a
                  href="${paginationUrl}"
                  data-href="${currentPage - 1}"
                  class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                  aria-label="Previous Page"
                >
                    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                </a>
            `;
            paginationList.appendChild(prevItem);
        }

        for (let i = 1; i <= pageNum; i++) {
            const paginationItem = document.createElement('li');
            const isActive = i === currentPage;
            paginationUrl.searchParams.set('p', i);

            paginationItem.classList.add('pagination-ajax__item');

            paginationItem.innerHTML = `
                <a
                ${!isActive ? `href="${paginationUrl}"` : ''}
                role="link"
                ${isActive ? 'aria-disabled="true" aria-current="page"' : ''}
                class="pagination__item ${isActive ? 'pagination__item--current light' : 'link'}"
                data-href="${i}"
                aria-label="Page ${i}"
                >
                ${i}
                </a>
            `;

            paginationList.appendChild(paginationItem);
        }

        if (currentPage < pageNum) {
            const nextItem = document.createElement('li');
            paginationUrl.searchParams.set('p', currentPage + 1);
            nextItem.innerHTML = `
                <a
                  href="${paginationUrl}"
                  data-href="${currentPage + 1}"
                  class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                  aria-label="Next Page"
                >
                    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                </a>
            `;
            paginationList.appendChild(nextItem);
        }

        const allPaginationLinks = pagination.querySelectorAll('a');

        allPaginationLinks.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();
                paginationHandler(anchor);
            });
        });
    }
}

function toggleArticlesByPagination(articlesHtml) {
    if (articlesHtml) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(articlesHtml, 'text/html');
        const articles = doc.querySelectorAll('.articles__article');
        const pagiConfig = initPagination(articles);
        let result;

        if (articles.length) {
            articles.forEach((article, index) => {
                if (!(pagiConfig.startIndex <= index && index <= pagiConfig.endIndex)) {
                    article.classList.add('hide');
                }
            });

            result = Array.from(articles).map(article => article.outerHTML).join('');

            return result;
        }
    }
}

// Update state for checkbox
function updateCheckboxState() {
    const checkboxes = document.querySelectorAll('#blogFilterForm input[type=checkbox]');
    const checkboxesMobile = document.querySelectorAll('#blogFilterFormMobile input[type=checkbox]');
    const tags = getQueryFromUrl('tags');

    checkboxes.forEach((checkbox) => {
        const checkboxValue = checkbox.value.toLowerCase().replace(/\s+/g, '-');

        if (tags.includes(checkboxValue)) {
            checkbox.checked = true;
        }
    });

    checkboxesMobile.forEach((checkbox) => {
        const checkboxValue = checkbox.value.toLowerCase().replace(/\s+/g, '-');

        if (tags.includes(checkboxValue)) {
            checkbox.checked = true;
        }
    });
}

// Handle pagination
function paginationHandler(anchor) {
    if (anchor) {
        const page = anchor.getAttribute('data-href');

        updateUrlWithQuery('paginate', page);
    }
}

function updatePagination() {
    const pagination = document.querySelectorAll('.pagination-ajax');
    const prevItem = pagination.querySelector('.pagination__item--prev');
    const nextItem = pagination.querySelector('.pagination__item--next');
    const currentPage = getQueryFromUrl('paginate');

}

document.addEventListener("DOMContentLoaded", function () {
    updateArticlesByTags();
});

document.querySelectorAll('#blogFilterForm input[type=checkbox]').forEach(checkbox => {
    checkbox.addEventListener('change', () => handleDesktopFilterChange(checkbox));
});

document.querySelectorAll('.pagination-ajax a').forEach(pagiLink => {
    pagiLink.addEventListener('click', () => paginationHandler(pagiLink));
});

const applyButton = document.getElementById('filter-mobile-apply');
const clearButton = document.getElementById('filter-mobile-clear');

if (applyButton) {
    applyButton.addEventListener('click', applyMobileFilter);
}

if (clearButton) {
    clearButton.addEventListener('click', clearMobileFilter);
}